import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSolana } from '../../hooks/useSolana';
import { BodyMedium } from '../Texts';
import { useConnectWallet, usePrivy, useUser } from '@privy-io/react-auth';
import { hapticsImpactLight } from '../../common/haptic';
import { useLoginWithSiws } from '@privy-io/react-auth';

import WalletIcon from '../../assets/icons/wallet.svg?react';
import { VerticalLine } from '../NavUserProfile';

const WalletConnectButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  padding: 12px;
  background-color: ${({ theme }: { theme: any }) =>
    theme.background.secondary};
  color: ${({ theme }: { theme: any }) => theme.primary.primary};
  cursor: pointer;
`;

export const truncateAddress = (address) => {
  if (!address) return '';
  return `${address.slice(0, 3)}...${address.slice(-3)}`;
};

const WalletConnectButton = ({
  onConnectedClick,
}: {
  onConnectedClick: () => void;
}) => {
  const { externalWallet } = useSolana();

  const { ready, authenticated } = usePrivy();

  const { connectWallet } = useConnectWallet();

  const { generateSiwsMessage, loginWithSiws } = useLoginWithSiws();

  useEffect(() => {
    const loginOrLink = async () => {
      if (externalWallet && ready && !authenticated) {
        const message = await generateSiwsMessage({
          address: externalWallet.address,
        });
        const encodedMessage = new TextEncoder().encode(message);
        const results = await externalWallet.signMessage({
          message: encodedMessage,
        });
        await loginWithSiws({
          message,
          signature: Buffer.from(results.signature).toString('base64'),
        });
      }
    };
    loginOrLink();
  }, [externalWallet, ready, authenticated]);

  const handleClick = () => {
    hapticsImpactLight();
    if (externalWallet) {
      onConnectedClick();
    } else {
      connectWallet();
    }
  };

  if (!externalWallet) {
    return null;
  }

  return (
    <>
      <WalletConnectButtonContainer onClick={handleClick}>
        <WalletIcon width={20} height={20} style={{ color: 'inherit' }} />
        <BodyMedium>
          {externalWallet
            ? truncateAddress((externalWallet as any)?.address)
            : 'Connect'}
        </BodyMedium>
      </WalletConnectButtonContainer>
      <VerticalLine />
    </>
  );
};

export default WalletConnectButton;
